import React from 'react';
import { SplitPanelBody } from '@web/components';
import dogImg from '../../images/CheckoutConfirmation/dog.png';
import dogPawIcon from '../../images/CheckoutConfirmation/dog-paw.svg';
import dogKissImg from '../../images/CheckoutConfirmation/dog-kiss.png';
import ollieBoxIcon from '../../images/CheckoutConfirmation/ollie-box.svg';
import twitterIcon from '../../images/Icons/twitter.svg';
import pinterestIcon from '../../images/Icons/pinterest.svg';
import instagramIcon from '../../images/Icons/instagram.svg';
import facebookIcon from '../../images/Icons/facebook.svg';
import spotifyIcon from '../../images/Icons/spotify.svg';
import tiktokIcon from '../../images/Icons/tiktok.svg';
import heroImage from '../../images/onboarding/confirmation-hero.png';
import googlePlayStoreButtonImage from '../../images/account/google-play-button.svg';
import appleStoreButtonImage from '../../images/account/apple-button.svg';
import ollieAppImage from '../../images/CheckoutConfirmation/ollie-health-screenings.png';
import rafImage from '../../images/CheckoutConfirmation/all-products.png';
import { Referral } from './Referral';

export const confirmationHeroProps = {
  headline: 'Congrats on choosing the right food for your pup',
  headlineVariants: [
    {
      headline:
        'Manage your box, try Health Screenings, and get $5 off your next box with the Ollie app!',
    },
  ],
  subheadline: 'Fresh, healthy dog food delivered to your door.',
  image: heroImage,
  horizontalOrientation: 'left',
  cta: {
    text: 'Dig in',
    target: '#',
  },
  backgroundColor: 'hero.spinach',
  fontColor: 'text.lightest',
  divider: false,
  footer: <p>Your pup's starter box is estimated to arrive next January 1st</p>,
};

export const confirmationBanners = [
  {
    component: 'confirmation_banner',
    header: 'Download our mobile app',
    description:
      'The proof will be in their poop—our free Transition Digestion Screening will help ensure a smooth start for your pup.',
    image: {
      src: ollieAppImage,
      alt: '',
    },
    cta: [
      {
        component: 'social_button',
        image: {
          src: appleStoreButtonImage,
          alt: 'Download on the App Store',
        },
        href: 'https://apps.apple.com/us/app/ollie-human-grade-dog-food/id1614301164',
        openNewTab: true,
      },
      {
        component: 'social_button',
        image: {
          src: googlePlayStoreButtonImage,
          alt: 'Get it on Google Play',
        },
        href: 'https://play.google.com/store/apps/details?id=com.ollie.mobile_app',
        openNewTab: true,
      },
    ],
  },
  {
    component: 'confirmation_banner',
    header: 'Refer a friend to Ollie',
    description: 'Get $25 credit when your friends join the pack.',
    image: {
      src: rafImage,
      alt: '',
    },
    cta: [
      {
        text: 'Start Sharing',
        target: '#',
      },
    ],
  },
  {
    component: 'confirmation_banner',
    header: 'Refer a friend to Ollie',
    description: 'Get $25 credit when your friends join the pack.',
    image: {
      src: rafImage,
      alt: '',
    },
    cta: [
      {
        text: 'Start Sharing',
        target: '#',
      },
    ],
  },
];

export const confirmationPoll = {
  component: 'confirmation_poll',
  pollPrompt: 'What were you feeding your dog before Ollie?',
  options: [
    {
      name: 'Option 1',
      value: '0',
    },
    {
      name: 'Option 2',
      value: '1',
    },
    {
      name: 'Option 3',
      value: '2',
    },
    {
      name: 'Option 4',
      value: '3',
    },
    {
      name: 'Option 5',
      value: '4',
    },
    {
      name: 'Option 6',
      value: '5',
    },
  ],
};

export const getSocialProps = {
  component: 'get_social_component',
  header: 'Get Social',
  description:
    'Join our community and tag @ollie to show us us what you and your pup are up to.',
  icons: [
    {
      image: {
        src: instagramIcon,
        alt: 'Instagram icon',
      },
      href: 'https://www.mlb.com/',
      opensNewTab: false,
    },
    {
      image: {
        src: facebookIcon,
        alt: 'Facebook icon',
      },
      href: 'https://www.mlb.com/',
      opensNewTab: true,
    },
    {
      image: {
        src: spotifyIcon,
        alt: 'Spotify icon',
      },
      href: 'https://www.mlb.com/',
      alt: 'Spotify icon',
      opensNewTab: true,
    },
    {
      image: {
        src: tiktokIcon,
        alt: 'TikTok icon',
      },
      href: 'https://www.mlb.com/',
      alt: 'TikTok icon',
      opensNewTab: true,
    },
    {
      image: {
        src: twitterIcon,
        alt: 'Twitter icon',
      },
      href: 'https://www.mlb.com/',

      opensNewTab: true,
    },
  ],
};

export const splitPanels = [
  {
    image: {
      alt: `Dog`,
      src: dogImg.src,
    },
    backgroundColor: `hero.spinach`,
    alignImage: 'right',
    centered: false,
    content: (
      <SplitPanelBody
        heading={`Refer and Earn $40`}
        body={
          <>
            <p>
              Invite a friend to try Ollie with a special discount and get $40
              off your next box.
            </p>
            <Referral />
          </>
        }
        icon={{
          alt: 'Dog Paw - Refer and Earn',
          src: dogPawIcon.src,
          width: dogPawIcon.width,
          height: dogPawIcon.height,
        }}
      />
    ),
  },
  {
    content: (
      <SplitPanelBody
        icon={{
          alt: 'Dog',
          src: ollieBoxIcon.src,
          width: ollieBoxIcon.width,
          height: ollieBoxIcon.height,
        }}
        heading={`Welcome to the pack`}
        body={
          <p>
            Join our community and tag #MyOllie to show us us what you and your
            pup are up to.
          </p>
        }
        socialMediaIcons={[
          {
            src: instagramIcon.src,
            alt: 'Instagram',
            url: 'https://www.instagram.com/ollie/',
          },
          {
            src: facebookIcon.src,
            alt: 'Facebook',
            url: 'https://www.facebook.com/MyOllie',
          },
          {
            src: twitterIcon.src,
            alt: 'Twitter',
            url: 'https://twitter.com/olliepets',
          },
          {
            src: tiktokIcon.src,
            alt: 'Tiktok',
            url: 'https://www.tiktok.com/@ollie',
          },
          {
            src: pinterestIcon.src,
            alt: 'Pinterest',
            url: 'https://www.pinterest.com/myolliedotcom/',
          },
          {
            src: spotifyIcon.src,
            alt: 'Spotify',
            url: 'https://open.spotify.com/user/ski5m70d8oulhj06d5ss6w1xm',
          },
        ]}
      />
    ),
    image: {
      alt: `Dog`,
      src: dogKissImg.src,
    },
    backgroundColor: `secondary.egg`,
    alignImage: 'left',
    centered: false,
  },
];

export const frequencyCalloutsListProps = [
  { body: 'one' },
  { body: 'two' },
  { body: 'three' },
];

export const boxFrequencyHeader = 'Choose your box frequency';
export const FREQUENCY_ERROR_MESSAGE =
  'Your shipping frequency has not been updated';
export const FREQUENCY_SAVED_TEXT = `✓ Frequency saved!`;
export const FREQUENCY_SAVED_DETAILS_TEXT =
  'You can edit your frequency any time by logging into the website or app.';
